// extracted by mini-css-extract-plugin
export var askAiIcon = "_pp-9";
export var container = "_pp-0";
export var groupSeparator = "_pp-a";
export var highlight = "_pp-4";
export var resultIcon = "_pp-5";
export var resultItem = "_pp-7";
export var resultSubtitle = "_pp-3";
export var resultTitle = "_pp-2";
export var resultsList = "_pp-1";
export var searchGroup = "_pp-6";
export var selected = "_pp-8";